import { Route } from "react-router-dom";
import CreateAssignment from "../../Modules/Admin/Screens/Assignments/CreateAssignment";
import CreateAssignmentQuestion from "../../Modules/Admin/Screens/Assignments/Questions/CreateAssignmentQuestion";
import EditAssignmentQuestion from "../../Modules/Admin/Screens/Assignments/Questions/EditAssignmentQuestion";
import ImportAssignmentQuestion from "../../Modules/Admin/Screens/Assignments/Questions/ImportAssignmentQuestion";
import AssignmentDetails from "../../Modules/Admin/Screens/Assignments/AssignmentDetails";
import Assignments from "../../Modules/Admin/Screens/Assignments/Assignments";
import PreviewAssignmentQuestion from "../../Modules/Admin/Screens/Assignments/Questions/PreviewAssignmentQuestion";
import FolderListing from "../../Modules/Admin/Screens/Assignment_Folders/FolderListing";
import AssignmentsForStudent from "../../Modules/Admin/Components/ManageClusterTabs/AssignmentsForStudent.jsx";

const AssignmentRoutes = [
  <Route
    key="assignments"
    path="/admin/assignment-folders/:folderid/assignments"
    element={<Assignments />}
  />,
  <Route
    key="create-assignment"
    path="/admin/assignments/create-assignment"
    element={<CreateAssignment />}
  />,
  <Route
    key="assignmentsForStudent"
    path="/assignments-for-student"
    element={<AssignmentsForStudent />}
  />,
  <Route
    key="assignments"
    path="/admin/assignment-folders"
    element={<FolderListing />}
  />,
  <Route
    key="assignmentDetails"
    path="/admin/assignment-folders/:folderid/assignments/:id"
    element={<AssignmentDetails />}
  />,
  <Route
    key="createAssignmentQuestion"
    path="/admin/assignment-folders/:folderid/assignments/:id/add-question"
    element={<CreateAssignmentQuestion />}
  />,
  <Route
    key="editAssignmentQuestion"
    path="/admin/assignment-folders/:folderid/assignments/:assignmentid/edit-question/:assignmentQuestionId"
    element={<EditAssignmentQuestion />}
  />,
  <Route
    key="importAssignmentQuestion"
    path="/admin/assignment-folders/:folderid/assignments/:assignmentid/import-question"
    element={<ImportAssignmentQuestion />}
  />,
  <Route
    key="create-assignment-question"
    path="/admin/assignments/:id/add-question"
    element={<CreateAssignmentQuestion />}
  />,
  <Route
    key="preview-assignment-question"
    path="/admin/assignments/:assignmentId/preview-question/:questionId"
    element={<PreviewAssignmentQuestion />}
  />,
];

export default AssignmentRoutes;
